export const DOMAIN_API = 'https://api.eboxenterprises.com';
